import $ from 'jquery'
export function shrinkSideBar() {
  
$('#shrinkSide').on('click', function () {
    $('.sidebar').css('width', '70px');
    $('.sidebar-wrapper').css('width', '70px');
    $('.main-panel').css('width', 'calc(100% - 70px)');
    $('.sideTitle').hide();
    $('#expandSide').removeAttr('hidden')
    $('#shrinkSide').attr('hidden', "true")
    $('.changeSize').css('font-size', '22px')
    $('.changeSizeText').css('color', 'transparent')
    $('li.active > a').css('background-color', 'transparent');
    $('li.active > a').css('box-shadow', '0');
    $('.arrowIcon').removeAttr('hidden');
    $('#countPesanan').hide()
    $('.user').hide()

    setTimeout(function () {  
        $('#logoChange').attr('src', 'https://siplah.eurekabookhouse.co.id/assets/front/images/icons/favicon_eureka_g7g_icon.ico')
    }, 400)
    
        //Expand Button
        $('#expandSide').on('click', function () {
            $('.sidebar').css('width', '260px');
            $('.sidebar-wrapper').css('width', '260px');
            $('.main-panel').css('width', 'calc(100% - 260px)');
            $('#shrinkSide').removeAttr('hidden')
            $('#expandSide').attr('hidden', "true")
            $('.arrowIcon').attr('hidden', '');

            setTimeout(function () {
                $('.sideTitle').show();
                $('.changeSize').css('font-size', '')
                $('.changeSizeText').css('color', '#79829c')
                $('li.active > a > p').css('color', 'white')
            },150)

            setTimeout(function () {
                $('.user').show()
            },180)

            setTimeout(function () {
                $('li.active > a').css('background-color', '#ffffff34');
                $('li.active > a').css('box-shadow', '0 1px 15px 1px rgba(39, 39, 39, 0.1)');
                $('#countPesanan').show()
            },350)
        
            $('#logoChange').attr('src', 'https://cdn.eurekabookhouse.co.id/ebh/mall/logo_siplah_seller.png')
        })    

}) 
     const screenMatch = window.screen.availWidth;
     if (screenMatch < 1025) {
         $('#shrinkSide').attr('hidden', "true")
         $('#expandSide').attr('hidden', "true")
     }
     $(window).on('resize', function () {
         if ($(window).width() < 1025) {
             $('#shrinkSide').attr('hidden', "true")
             $('#expandSide').attr('hidden', "true")
         } else {
             $('#shrinkSide').removeAttr('hidden')
            //  $('#expandSide').removeAttr('hidden')
         }
     });   

    const pembayaranText = $.makeArray($('ul.uLpembayaran li>a>p').text().replace(' ','').split('  '))

    $('#semua').attr({
        'data-toggle':"tooltip",
        'data-placement':"right",
        title:pembayaranText[0]
    })

    $('#kurangLengkap').attr({
        'data-toggle':"tooltip",
        'data-placement':"right",
        title:pembayaranText[1]
    })

    $('#verifikasi').attr({
        'data-toggle':"tooltip",
        'data-placement':"right",
        title:pembayaranText[2]
    })

    $('#diteruskanKePenyedia').attr({
        'data-toggle':"tooltip",
        'data-placement':"right",
        title:pembayaranText[3]
    })

    $('.tooltipsDropDown').hover(
        function () {
        $('#pembayaran').addClass('show');
        $('#pembayaran > ul > li > a > p').removeClass('ml-5');
    }, function() {
        $('#pembayaran').removeClass('show');
    }
    )
}